/**
 * Na Home: as últimas fotos do grupo em miniaturas quadradas, no lugar do
 * botão "Memórias". Vem do mesmo endpoint da lista, com `limit=6` — nada novo
 * na API.
 *
 * Home v2 (PO, 19/09/2026): enxuto — uma linha de 3 (a terceira vaga é o
 * "+ foto" quando há menos de 3), e "ver mais" abre a segunda linha. Sem
 * foto nenhuma, só o "+ foto": é o convite para começar.
 */
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { memoriasApi } from './api';
import { useConfigMedia } from './comum';

const QUANTAS = 6;
const POR_LINHA = 3;

export function FotosRecentesNaHome() {
  const { tripId } = useTrip();
  const config = useConfigMedia();
  const ligado = config.data?.media === true;
  const [aberto, setAberto] = useState(false);
  const recentes = useQuery({
    queryKey: ['memorias', tripId, 'recentes', QUANTAS],
    queryFn: () => memoriasApi.listar(tripId, undefined, { limit: QUANTAS }),
    enabled: ligado && tripId.length > 0,
    staleTime: 30_000,
  });
  const fotos = recentes.data?.items ?? [];
  if (!ligado || !recentes.isSuccess) return null;
  const visiveis = aberto ? fotos.slice(0, QUANTAS) : fotos.slice(0, POR_LINHA);
  const temMais = fotos.length > POR_LINHA;
  return (
    <section className="home-fotos" data-testid="home-fotos" data-fotos={fotos.length}>
      <div className="nv-section-label home-fotos__titulo">
        <span>{fotos.length === 0 ? 'Memórias' : 'Fotos recentes'}</span>
        {fotos.length > 0 && (
          <Link to="/memorias" className="home-fotos__ver">
            Ver todas <Icon name="avancar" size={14} />
          </Link>
        )}
      </div>
      <div className="home-fotos__grade" data-testid="home-fotos-grade">
        {visiveis.map((f) => (
          <Link key={f.id} to="/memorias" aria-label="Ver nas Memórias">
            <img src={f.thumbUrl} alt="" loading="lazy" />
          </Link>
        ))}
        {(fotos.length === 0 || visiveis.length < POR_LINHA || aberto) && (
          <Link to="/memorias/enviar" className="home-fotos__mais" aria-label="Enviar foto" data-testid="home-foto-enviar">
            <Icon name="criar" size={22} />
            <span>foto</span>
          </Link>
        )}
      </div>
      {temMais && (
        <button type="button" className="home-fotos__toggle" onClick={() => setAberto((v) => !v)} aria-expanded={aberto} data-testid="home-fotos-mais">
          {aberto ? 'Ver menos' : `Ver mais ${fotos.length - POR_LINHA}`}
          <Icon name={aberto ? 'fechar' : 'avancar'} size={14} />
        </button>
      )}
    </section>
  );
}
